import { isNativeAppShell } from './mobileView';

const COMPACT_VIEWPORT_QUERY = '(max-width:899px)';

/** Narrow viewport — same breakpoint as App mobile shell. */
export function isCompactViewport() {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.matchMedia(COMPACT_VIEWPORT_QUERY).matches;
}

/**
 * True when the mobile app shell is active.
 * Native Capacitor (phone + iPad + Android tablet) always uses the app shell.
 * Web uses the shell only on narrow viewports (or when the shell class is present).
 */
export function isMobileShellLayout() {
  if (isNativeAppShell()) {
    return true;
  }
  if (typeof document === 'undefined') {
    return isCompactViewport();
  }
  return (
    isCompactViewport()
    || document.documentElement.classList.contains('mobile-app-shell')
    || Boolean(document.querySelector('.mobile-app-shell'))
  );
}
